import { createContext, useContext } from 'react';

/**
 * Deep-Link-Parameter für Apps
 */
export interface WindowParams {
  [key: string]: string | number | boolean | undefined;
}

/**
 * Standard Props die jede App-Komponente erhält
 */
export interface WindowAppProps {
  /**
   * Eindeutige ID des Fensters (UUID)
   * Kann verwendet werden um den Untertitel zu aktualisieren:
   * updateWindowSubtitle(windowId, 'Neuer Untertitel')
   */
  windowId: string;

  /**
   * Optional: Callback zum Schließen des Fensters
   * Nützlich für Apps mit eigenem Close-Button
   */
  onClose?: () => void;

  /**
   * Optional: Deep-Link-Parameter für die App
   * Ermöglicht Zugriff auf URL-Parameter wie ?ka=Marketing&folder=123
   */
  params?: WindowParams;
}

/**
 * Context für Window-Informationen
 * Ermöglicht verschachtelten Komponenten Zugriff auf windowId
 */
export const WindowContext = createContext<WindowAppProps | null>(null);

/**
 * Hook um auf Window-Context zuzugreifen
 * Funktioniert auch in tief verschachtelten Komponenten
 */
export function useWindowContext(): WindowAppProps | null {
  return useContext(WindowContext);
}
